import SideNavigation from "./SideNavigation";
import { MacScrollbar } from "mac-scrollbar";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  MainAppInitailAtom,
  MainAppSideBarExpandAtom,
  ResizingAtom,
  userInfoAtom,
} from "../atom";
import { AnimatePresence, motion } from "framer-motion";
import React, { useEffect, useState, useMemo } from "react";
import Topbar from "../components/Topbar";
import { navItems } from "../utils/NavItems";
import { Outlet, useLocation } from "react-router-dom";
function BaseOutlet() {
  const userInfo = useRecoilValue(userInfoAtom);

  // Filter navigation items based on user type
  const filteredNavItems = useMemo(() => {
    if (!userInfo) {
      return navItems;
    }

    const shouldHideRoutes = userInfo.channel_partner !== null;

    return navItems
      ?.filter((item) => {
        if (item.title === "Dashboard" && shouldHideRoutes) {
          return false;
        }
        return true;
      })
      .map((item) => {
        if (item.title === "Project Management") {
          if (shouldHideRoutes) {
            return {
              ...item,
              subItems: item.subItems || [],
            };
          } else {
            return {
              ...item,
              subItems: [
                ...(item.subItems || []),
                {
                  title: "Pending Go-Live Approval",
                  to: "/projects/approval-list",
                  permission: "view_project",
                },
              ],
            };
          }
        }
        return item;
      });
  }, [userInfo]);

  const [sidebarExpand, setSidebarExpand] = useRecoilState(
    MainAppSideBarExpandAtom
  );
  const [containerResizing, setContainerResizing] =
    useRecoilState(ResizingAtom);
  const [initial, setInitial] = useRecoilState(MainAppInitailAtom);
  const location = useLocation();
  useEffect(() => {
    if (initial) {
      setTimeout(() => setInitial(false), 900);
    }
    const width = window.screen.width;
    setSidebarExpand(width > 1280 ? true : false);
  }, [initial]);

  useEffect(() => {
    let timeout: any;
    if (containerResizing) {
      timeout = setTimeout(() => {
        setContainerResizing(false);
      }, 800);
    }
    return () => clearTimeout(timeout);
  }, [containerResizing]);

  if (!userInfo) {
    return <div className=""></div>;
  }

  return (
    <>
      <MacScrollbar>
        <div className="h-screen overflow-y-auto overflow-x-hidden ">
          <SideNavigation
            navItems={filteredNavItems}
            sidebarExpand={sidebarExpand}
            setSidebarExpand={setSidebarExpand}
            containerResizing={containerResizing}
            setContainerResizing={setContainerResizing}
          />
          <motion.div
            animate={sidebarExpand ? { paddingLeft: 234 } : { paddingLeft: 48 }}
            transition={{ duration: 0.4 }}
          >
            <div className="h-10 sticky top-0 z-[43]">
              <Topbar initial={initial} />
            </div>
            <motion.div
              key={location.pathname}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.4 }}
              className="h-[calc(100vh-2.5rem)] custom-scrollbar overflow-y-auto"
            >
              <Outlet />
            </motion.div>
          </motion.div>
        </div>
      </MacScrollbar>
    </>
  );
}

export default BaseOutlet;
